import * as React from "react";
import { IParagraphBodyProps } from "./ParagraphBodyProps";
import { StyledContainer, Description } from "./ParagraphBodyHelpers";
import { graphql } from "gatsby";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

export const ParagraphBody: React.FC<IParagraphBodyProps> = (props) => {
  const { isMobileOnly } = useMobileDetectContext();
  return (
    <>
      {props.node?.field_body && props.node.field_body.processed ? (
        <StyledContainer>
          {isMobileOnly ? (
            <Description
              text={props.node.field_body.value}
              themeColor={"black"}
            />
          ) : (
            <div
              dangerouslySetInnerHTML={{ __html: props.node.field_body.value }}
            />
          )}
        </StyledContainer>
      ) : (
        <></>
      )}
    </>
  );
};

export const fragment = graphql`
  fragment ParagraphBody on paragraph__paragraph_body {
    id
    relationships {
      field_sites {
        machine_name
      }
    }
    field_body {
      summary
      processed
      value
    }
  }
`;

export default ParagraphBody;
